let checkPath;

let stagingURL = window.location.hostname === "ubatemp.retailcare.com.au";
let localhostURL = window.location.hostname === "localhost";

export default checkPath = stagingURL || localhostURL;
